<ul class="flex flex-wrap text-sm font-medium text-center text-gray-500 dark:text-gray-400">
  <li class="me-2" *ngFor="let item of tabs">
    <button
      [ngClass]="{
        'bg-system-700 dark:bg-gray-800 text-white dark:text-white ': tabSelected === item.value,
        'bg-transparent hover:bg-gray-100  hover:text-gray-900': tabSelected !== item.value,
      }"
      class="px-4 py-3 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 dark:hover:text-white gap-1"
      systemIconDirective
      [iconName]="item.icon"
      (click)="changeTab(item.value)"
      iconType="outline"
      [iconPosition]="'left'"
    >
      {{ item.label }}
    </button>
  </li>
</ul>
